import { useRecoilCallback, useRecoilState, useRecoilValue } from "recoil";
import { useState, useEffect } from "react";
import { ServiceWaitList } from "src/services/agenda/waitlist";
import {
  professionalsWaitListState,
  specialityWaitListState,
} from "../state/atoms";
import { dayDefaultAvailableState } from "src/SearchHours/components/calendars/state/atoms";
import useCatchErrorApi from "src/shared/hooks/useCatchErrorApi";

export const useProfessionals = () => {
  const { catchErrorApi } = useCatchErrorApi();
  const [professionals, setProfessionals] = useRecoilState(
    professionalsWaitListState
  );
  const [specialitySelected] = useRecoilState(specialityWaitListState);
  const dayDefaultAvailable = useRecoilValue(dayDefaultAvailableState);

  const [loading, setLoading] = useState(false);

  const loadProfessionals = useRecoilCallback(
    ({ snapshot }) =>
      async () => {
        setLoading(true);
        try {
          let especialidadCode = specialitySelected.code;
          let date = dayDefaultAvailable?.toISOString().split("T")[0];

          const response = await ServiceWaitList.getProfessionals(
            especialidadCode,
            date
          );
          setProfessionals(response.data);
        } catch (error) {
          catchErrorApi(error);
        } finally {
          setLoading(false);
        }
      },
    [specialitySelected, dayDefaultAvailable]
  );

  useEffect(() => {
    loadProfessionals();
  }, [specialitySelected, loadProfessionals]);

  return { professionals, loading, loadProfessionals };
};
